import { Component, OnInit, Input } from '@angular/core';
import { LayerSelectionDialogService } from '../dialogs/layer-selection-dialog/layer-selection-dialog.service.';
import { MapService } from 'src/app/services/map.service';
import { SLMap } from 'src/app/model/sl-map';
import { ResultHistory } from 'src/app/model/result-history';
import { ResultsService } from 'src/app/services/results.service';
import { ButtonSize } from '../button/button.component';

@Component({
  selector: 'app-gallery-button',
  templateUrl: './gallery-button.component.html',
  styleUrls: ['./gallery-button.component.scss']
})
export class GalleryButtonComponent implements OnInit {

  constructor(private layerSelector: LayerSelectionDialogService, private resultsSvc: ResultsService) { }
  history: ResultHistory = null;
  @Input() size: ButtonSize = 'md';

  get isHidden(): boolean {
    if (this.history === null) {
      return true;
    }
    return this.history.momentCount <= 0;

  }
  ngOnInit(): void {
    this.history = this.resultsSvc.history;
  }
  ShowGallery() {
    this.layerSelector.ShowGallery();


  }

}
